import React from 'react';
import CtaButton from '~/components/shared/ctaButton/CtaButton';
import FadeInContainer from '~/components/shared/fadeInContainer/FadeInContainer';
import FeaturedCta from '~/components/widgets/featuredCtaGroup/FeaturedCta';
import Sunrise from '~/components/shared/sunrise/Sunrise';
import clsx from 'clsx';

const HomepageHeroSlide = ({ slide }) => {
  const {
    title,
    description,
    media,
    ctaButton,
    secondCtaButton,
    featuredCtas,
    hasSunrise,
    colorScheme
  } = slide;

  return (
    <>
      <div
        className={clsx(
          'homepage-hero-container',
          colorScheme.toLowerCase(),
          hasSunrise && 'gradient'
        )}
      >
        <div className="container-fluid">
          {hasSunrise && colorScheme !== 'white' && colorScheme !== 'offset' && <Sunrise />}
          <FadeInContainer direction="left">
            <div className="homepage-hero-content">
              <h1>{title}</h1>
              <p>{description}</p>
              {ctaButton.hasCtaButton && (
                <div className="button-wrapper">
                  <CtaButton {...ctaButton} />
                  <CtaButton {...secondCtaButton} />
                </div>
              )}
            </div>
          </FadeInContainer>
          <FadeInContainer direction="right">
            <img className="homepage-hero-image" src={media} alt={title} />
          </FadeInContainer>
        </div>
      </div>
      {!!featuredCtas?.length && (
        <div className="container-fluid featured-ctas">
          {featuredCtas.map((cta) => (
            <FeaturedCta cta={cta} key={cta.ctaName} />
          ))}
        </div>
      )}
    </>
  );
};

export default HomepageHeroSlide;
